import { Group, Select, Stack, Stepper } from "@mantine/core";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { useMemo } from "react";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import AddReminder from "./AddReminder";
import ReminderItem from "./ReminderItem";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";

const TabReminders = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);

  const sort = useLeadsSheetStore((s) => s.sort);
  const setSort = useLeadsSheetStore((s) => s.setSort);

  const orders = useMemo(() => {
    return [
      {
        label: lang.prm.details.filters.desc,
        value: "desc",
      },
      {
        label: lang.prm.details.filters.asc,
        value: "asc",
      },
    ];
  }, [lang.prm.details.filters.asc, lang.prm.details.filters.desc]);

  return (
    <Stack
      gap={0}
      flex={1}
      h={0}
      mih={"100%"}
      style={{ overflow: "auto" }}
      p={"lg"}
      px={0}
       id="reminders-tab"
    >
      <Group mb={"xs"} justify="space-between" pr={8}>
        <Select
          value={sort}
          data={orders}
          w={190}
          size="xs"
          onChange={setSort}
          leftSection={
            sort === "asc" ? (
              <IconArrowUp size={18} />
            ) : (
              <IconArrowDown size={18} />
            )
          }
        />

        <AddReminder />
      </Group>
      <Stepper
        active={0}
        iconSize={28}
        size="sm"
        radius={"lg"}
        styles={{ stepIcon: { border: "none", background: "none" } }}
        orientation="vertical"
      >
        {current?.calls?.map((item, index) => (
          <ReminderItem
            key={item?.id || index}
            item={item}
            isLast={index === current.calls.length - 1}
          />
        ))}
      </Stepper>
    </Stack>
  );
};

export default TabReminders;
